// extracted by mini-css-extract-plugin
module.exports = {"rotation":"MagazineSection_rotation__3g6nn"};